// extracted by mini-css-extract-plugin
export default {"resultImage":"resultImage--D3Jkl"};